import React from "react"
import { OffersCarousel } from "../OffersCarousel"
import type { TenantConfig, Offer, ClientUnpaidOrdersResponse } from "../../types"

interface DashboardHeroProps {
    config: TenantConfig | null;
    unpaidOrders: ClientUnpaidOrdersResponse | null;
    offers: Offer[];
    showScheduledSkeleton: boolean;
}

export const DashboardHero: React.FC<DashboardHeroProps> = ({
    config,
    unpaidOrders,
    offers,
    showScheduledSkeleton
}) => {
    return (
        <div className="relative">
            <div className="relative">
                <div className="relative bg-gradient-to-br from-gray-800 to-gray-900 dark:from-gray-900 dark:to-black rounded-2xl p-6 shadow-lg border border-gray-700 dark:border-gray-800 overflow-hidden">
                    <div className="absolute top-0 right-0 w-40 h-40 bg-white/5 rounded-full blur-3xl"></div>
                    <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/5 rounded-full blur-2xl"></div>

                    <div className="relative flex items-start gap-4 z-10">
                        {config?.logotype ? (
                            <img
                                src={config?.logotype}
                                alt="Logo"
                                className="w-16 h-16 object-contain flex-shrink-0 bg-white rounded-full p-2 shadow-inner"
                                onError={(e) => {
                                    e.currentTarget.style.display = 'none';
                                    const fallback = document.createElement('div');
                                    fallback.className =
                                        'w-16 h-16 flex items-center justify-center text-4xl bg-white rounded-full';
                                    fallback.textContent = '🍽️';
                                    e.currentTarget.parentElement?.insertBefore(fallback, e.currentTarget);
                                }}
                            />
                        ) : (
                            <div className="w-16 h-16 flex items-center justify-center text-4xl bg-white rounded-full">
                                🍽️
                            </div>
                        )}

                        <div className="flex-1">
                            <h2 className="text-xl font-bold text-white mb-1">
                                {config?.tenant_name || 'Bienvenido'}
                            </h2>
                            <p className="text-gray-300 text-sm whitespace-pre-line">
                                {config?.business_description ||
                                    `${unpaidOrders?.table_number ? `Mesa ${unpaidOrders.table_number}` : ''}. Explora nuestro delicioso menú y haz tu primer pedido`}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {!showScheduledSkeleton && (
                <div className="p-6">
                    <OffersCarousel offers={offers} onOfferClick={() => { }} />
                </div>
            )}
        </div>
    );
};
